import { Helmet } from "react-helmet-async";
import type { BlogPosting, WebPage, WithContext } from "schema-dts";

type StructuredDataBlogSchemaProps = {
  author?: string;
  dateModified: string;
  datePublished: string;
  description: string;
  imageUrl: string;
  pathname: string;
  title: string;
};

export default function StructuredDataBlogSchema(
  {
    author = "WebGazer",
    dateModified,
    datePublished,
    description,
    imageUrl,
    pathname,
    title,
  }: StructuredDataBlogSchemaProps,
) {
  const blogPost: WithContext<BlogPosting> = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    author: {
      "@id": `${import.meta.env.VITE_BASE_URL}/#author`,
      "@type": "Person",
      name: author,
    },
    creator: {
      "@id": `${import.meta.env.VITE_BASE_URL}/#organization`,
    },
    dateCreated: datePublished,
    dateModified,
    datePublished,
    description,
    headline: title,
    image: {
      "@type": "ImageObject",
      url: `${import.meta.env.VITE_BASE_URL}/${imageUrl}`,
    },
    inLanguage: "en-US",
    isFamilyFriendly: true,
    mainEntityOfPage: {
      "@id": `${import.meta.env.VITE_BASE_URL}/${pathname}#webpage`,
    },
    publisher: {
      "@id": `${import.meta.env.VITE_BASE_URL}/#organization`,
    },
    url: `${import.meta.env.VITE_BASE_URL}/${pathname}`,
  };

  const webpage: WithContext<WebPage> = {
    "@context": "https://schema.org",
    "@id": `${import.meta.env.VITE_BASE_URL}/${pathname}#webpage`,
    "@type": "WebPage",
    isPartOf: {
      "@id": `${import.meta.env.VITE_BASE_URL}/#website`,
    },
    mainEntity: blogPost,
    url: `${import.meta.env.VITE_BASE_URL}/${pathname}`,
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify([webpage, blogPost])}
      </script>
    </Helmet>
  );
}
